/**
 * Copyright 2018, IOOF Holdings Limited.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */
var runSagaEnhancer = function runSagaEnhancer(saga) {
  return function (identifier) {
    return function (store) {
      var _store$runSagas;

      if (process.env.NODE_ENV !== 'production' && typeof store.runSagas !== 'function') {
        throw new TypeError("'store.runSagas' function is missing: Unable to run saga '" + identifier + "'.");
      }

      store.runSagas((_store$runSagas = {}, _store$runSagas[identifier] = saga, _store$runSagas));
    };
  };
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Copyright 2018, IOOF Holdings Limited.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */
var flattenSagas = function flattenSagas(sagas, parentKey) {
  if (typeof sagas === 'function') {
    var _ref;

    return _ref = {}, _ref[parentKey.replace(/\//g, '.')] = sagas, _ref;
  }

  return Object.keys(sagas).reduce(function (sagaMap, key) {
    return _objectSpread2(_objectSpread2({}, sagaMap), flattenSagas(sagas[key], parentKey ? parentKey + "." + key : key));
  }, {});
};

var dynamicSagasEnhancer = function dynamicSagasEnhancer(sagaMiddleware) {
  return function (createHandlers) {
    return function (store) {
      var dynamicSagas = {};

      var runSagas = function runSagas(sagas) {
        var flattenedSagas = flattenSagas(sagas);
        Object.keys(flattenedSagas).filter(function (key) {
          return !dynamicSagas[key];
        }).forEach(function (key) {
          return dynamicSagas[key] = sagaMiddleware.run(flattenedSagas[key]);
        });
      };

      var cancelSagas = function cancelSagas(identifiers) {
        identifiers.filter(function (identifier) {
          return dynamicSagas[identifier];
        }).forEach(function (identifier) {
          var runningSaga = dynamicSagas[identifier];
          delete dynamicSagas[identifier];
          runningSaga.cancel();
        });
      };

      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      var handlers = createHandlers.apply(void 0, [store].concat(params));
      return _objectSpread2(_objectSpread2({}, handlers), {}, {
        runSagas: runSagas,
        cancelSagas: cancelSagas
      });
    };
  };
};

export { dynamicSagasEnhancer as dynamicSagas, runSagaEnhancer as runSaga };
